module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/mail-attachment-a5d1ddf5c994c2d3b72287425f5ac823.svg";